import {TiberForm} from "./tiber-form.js";

/**
 * Represents an HTML form specific implementation of the TiberForm class.
 * This class allows for creating and managing forms rendered in an HTML environment.
 * It extends the functionality of the base TiberForm class by defining the type of the form as "form".
 *
 * @extends TiberForm
 */
export class TiberFormHtmlForm extends TiberForm
{
    formType = "form";

    constructor(hostElement, configuration) {
        super(hostElement, configuration);
    }
}
